/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Button, Header, Icon } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { useDeviceMediaQuery } from '../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'

const BusyModeModal = ({onDismiss, onValidate}) => {
    const [t] = useTranslation()
    const {isMobile} = useDeviceMediaQuery()
    const [selectedDurationOption, setSelectedDurationOption] = useState(null)

    const durationOptions = [
        {valueInMinutes: 15, label: t('navbar.busy_mode.duration.minute', {count: 15})},
        {valueInMinutes: 30, label: t('navbar.busy_mode.duration.minute', {count: 30})},
        {valueInMinutes: 60, label: t('navbar.busy_mode.duration.hour', {count: 1})},
        {valueInMinutes: 120, label: t('navbar.busy_mode.duration.hour', {count: 2})},
    ]

    return (
      <div
        css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
        `}
      >
          <Header
            size={isMobile ? 'small' : undefined}
            css={css`
                text-align: center;
            `}
          >{t('navbar.busy_mode.confirm_activate_busy_mode')}</Header>

          <p>
              {t('navbar.busy_mode.you_will_no_longer_receive_new_orders')}
          </p>
          <div
            css={css`
                display: grid;
                gap: 1rem;
                grid-template-columns: repeat(${isMobile ? 2 : 4}, 1fr);
                margin-bottom: 2rem;
            `}
          >
              {durationOptions.map(durationOption => {
                  const isSelected = selectedDurationOption === durationOption.valueInMinutes
                  return (
                    <div key={durationOption.valueInMinutes}>
                        <Button
                          color="teal"
                          css={css`
                              &.ui.button {
                                  height: 100%;
                              }
                          `}
                          fluid
                          basic={!isSelected}
                          onClick={() => {
                              setSelectedDurationOption(prev => prev === durationOption.valueInMinutes ?
                                null :
                                durationOption.valueInMinutes)
                          }}
                        >
                            {durationOption.label}
                        </Button>
                    </div>
                  )
              })}
          </div>

          <div
            css={css`
                display: flex;
                align-items: stretch;
                flex-direction: column;
                width: 100%;
                gap: 1rem;
            `}
          >
              <Button
                fluid
                basic
                onClick={onDismiss}>
                  <Icon name="remove"/>
                  {t('global.cancel')}
              </Button>

              <Button
                fluid
                color="teal"
                css={css`
                    &.ui.button {
                        margin-bottom: 1rem;
                        height: 100%;
                    }
                `}
                onClick={() => onValidate({durationInMinutes: selectedDurationOption})}>
                  <Icon name="checkmark"/>
                  {t('global.validate')}
              </Button>
          </div>
      </div>

    )
}

export { BusyModeModal }
